import { render } from "./ShippingFeeRuleEditor.vue?vue&type=template&id=50a22e30"
import script from "./ShippingFeeRuleEditor.vue?vue&type=script&lang=js"
export * from "./ShippingFeeRuleEditor.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__